import React from 'react'
import clsx from 'clsx'

import { Info16 } from '@makyoapp/makyo-icon/icon'

export interface IntoProps {
  className?: string
  textClassName?: string
  children?: React.ReactNode
  isDanger?: boolean
  defaultTextStyle?: boolean
  gap?: 'short' | 'long'
}

export function Info(props: IntoProps) {
  let gap
  switch (props.gap) {
    case 'long':
      gap = 'gap-4'
      break
    case 'short':
    default:
      gap = 'gap-2'
      break
  }

  return (
    <div
      className={clsx(
        'flex items-center',
        gap,
        props.defaultTextStyle !== false && (props.isDanger ? 'red' : 'text-light'),
        props.className
      )}
    >
      <Info16 className='shrink-0 grow-0' />
      <div className={props.textClassName}>{props.children}</div>
    </div>
  )
}
